import { boot } from 'quasar/wrappers'
import showSearch from '../functions/show-search'

export default boot(({ app }) => {
	app.config.globalProperties.$showSearch = showSearch
})
